import { useQuery } from '@tanstack/react-query';
import { getDasTransactions } from '../../../services/das.service';

export const useDasTransactions = (filters = null, enabled = false) => {
  return useQuery({
    queryKey: [
      'dasTransactions',
      filters?.policyNumber || filters?.policy_number || 'all',
      filters?.transaction_type || 'all',
      filters?.date_from || '',
      filters?.date_to || ''
    ],
    queryFn: () => getDasTransactions(filters),
    enabled: !!enabled && !!filters,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    onError: (error) => {
      console.error('Error fetching DAS transactions:', error);
    }
  });
};
